import { useSearchStore } from "@/Stores/search";
import { computed } from "vue";

export function useSearch(storeKey) {
    const searchStore = useSearchStore();

    const query = computed(() => {
        return searchStore[storeKey];
    });

    const parsedQuery = computed(() => {
        return query.value ? query.value.trim().toLowerCase() : "";
    });

    const searchValues = computed(() => {
        return {
            search: parsedQuery.value,
        };
    });

    const handleSearchChange = (value) => {
        if (searchStore[storeKey] === undefined) {
            console.error(
                "The specified store key is not present in the search store."
            );
        }

        if (parsedQuery.value === value.trim().toLowerCase()) {
            return;
        }

        searchStore[storeKey] = value;
    };

    const handleClearSearch = () => {
        searchStore[storeKey] = "";
    };

    return {
        query,
        parsedQuery,
        searchValues,
        handleSearchChange,
        handleClearSearch,
    };
}
